import { SxProps, Theme } from '@mui/material/styles';

export const accountButtonStyles = (
    lightSurface: boolean, open: boolean, mini: boolean
): SxProps<Theme> => ({ palette, functions: { rgba } }: Theme) => {
    const { white, black, grey, info } = palette;

    const idle = lightSurface
        ? {
            bg: rgba(black.main, 0.04),
            border: rgba(black.main, 0.12),
            hoverBg: rgba(black.main, 0.07),
            hoverBorder: rgba(black.main, 0.24),
        }
        : {
            bg: rgba(white.main, 0.045),
            border: rgba(white.main, 0.12),
            hoverBg: rgba(white.main, 0.08),
            hoverBorder: rgba(white.main, 0.24),
        };

    const opened = lightSurface
        ? { bg: grey[200], border: grey[400], hoverBg: grey[300] }
        : { bg: rgba(white.main, 0.2), border: rgba(white.main, 0.24), hoverBg: rgba(white.main, 0.2) };

    const current = open ? opened : idle;

    return {
        width: '100%',
        minHeight: 44,
        display: 'flex',
        alignItems: 'center',
        justifyContent: mini ? 'center' : 'flex-start',
        gap: 1,
        px: mini ? 0 : 1.25,
        py: 1,
        border: '1px solid',
        borderColor: current.border,
        borderRadius: '8px',
        bgcolor: current.bg,
        transition: 'background-color 160ms ease, border-color 160ms ease',
        '&:hover': {
            borderColor: open ? current.border : idle.hoverBorder,
            bgcolor: open ? opened.hoverBg : idle.hoverBg,
        },
        '&:focus-visible': { outline: `2px solid ${info.main}`, outlineOffset: 2 },
        '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
    };
};

export const accountMenuStyles = (
    width: number | undefined, mini: boolean, dark: boolean
): SxProps<Theme> => ({
    width: mini ? 220 : width ?? 218,
    minWidth: mini ? 220 : width ?? 218,
    mt: '-10px',
    p: '6px',
    border: '1px solid',
    borderColor: dark ? 'rgba(255, 255, 255, 0.16)' : 'rgba(0, 0, 0, 0.12)',
    borderRadius: '8px',
    overflow: 'visible',
    boxShadow: dark ? '0 8px 24px rgba(0, 0, 0, 0.3)' : '0 8px 24px rgba(0, 0, 0, 0.14)',
    '&::after': {
        content: '""',
        position: 'absolute',
        bottom: -5,
        right: mini ? 'auto' : 20,
        left: mini ? 26 : 'auto',
        width: 10,
        height: 10,
        bgcolor: 'inherit',
        borderRight: '1px solid',
        borderBottom: '1px solid',
        borderColor: dark ? 'rgba(255, 255, 255, 0.16)' : 'rgba(0, 0, 0, 0.12)',
        transform: 'rotate(45deg)',
        pointerEvents: 'none',
    },
    '& .MuiMenuItem-root': {
        minHeight: 40,
        borderRadius: '5px',
        '&:hover, &:focus, &.Mui-focusVisible': {
            bgcolor: dark ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.06)',
        },
    },
});
